// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"ActivityContent_bookmark__1hxmH"};